import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ramp = defineConnector({
  identifier: "ramp",
  name: "Ramp",
  tagLine: "Corporate expense management",
  keywords: "corporate card spend expenses transactions bill pay",
  logo,
  protocol: "http",
  tags: ["productivity", "data"],
  defaultUrlPattern: () => "https://api\\.ramp\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [Ramp](https://app.ramp.com/) and navigate to **Settings** > **Developer** > **API Keys** to create a new API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Ramp API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.ramp.com/developer/v1/business",
  },
});
